export const useCsrft = () => {
  const csrftParamEl = document.querySelector("meta[name='csrf-param']")
  const csrfTokenEl = document.querySelector("meta[name='csrf-token']")
  const tokenName = csrftParamEl?.getAttribute('content')
  const tokenValue = csrfTokenEl?.getAttribute('content')

  return { tokenName: tokenName, tokenValue: tokenValue }
}
